import React, { Component } from 'react';
import { uniq } from 'lodash';
import cx from 'classnames';

export default class Filter extends Component {
  handleClick = (e, type) => {
    const clicked = e.target;
    const items = Array.from(e.currentTarget.children);
    items.forEach( item =>
      item.classList.remove('active')
    );

    clicked.classList.add('active');
    this.props.onChange(type, clicked.innerText, true);
  }

  render() {
    const { data } = this.props;
    const departments = uniq(data.map( item => item.department));
    const status = uniq(data.map( item => item.statusStudent));
    const payments = uniq(data.map( item => item.paymentsInfo));

    return (
      <div className="stats-wrapper">
      <p>Filtruj:</p>
      <ul className="filters-list">
        <li>
          <ul className="filter-list" onClick={(e) => this.handleClick(e, 'department')} >
            <li>All</li>
            {
              departments.map( item => <li key={item}>{item}</li>)
            }
          </ul>
        </li>
        <li>
          <ul className="filter-list" onClick={(e) => this.handleClick(e, 'statusStudent')}>
            <li>All</li>
            {
              status.map( item => <li key={item}>{item}</li>)
            }
          </ul>
        </li>
        <li>
          <ul className="filter-list" onClick={(e) => this.handleClick(e, 'paymentsInfo')}>
            <li>All</li>
            {
              payments.map( item => <li key={item}>{item}</li>)
            }
          </ul>
        </li>
      </ul>
    </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/modules/Admin/components/Filter.js